import { render, staticRenderFns } from "./SlideToggle.vue?vue&type=template&id=2cbe4e58"
import script from "./SlideToggle.vue?vue&type=script&lang=js"
export * from "./SlideToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports